<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts', 'jobOwners']"
      :quick-filters="['jobOwners']"
      :max-height-adjustment="60"
      :bulk-actions="jobBulkActions"
      @full-screen="fullscreen = $event"
    >
      <template #action="{ row }">
        <JobActionColumn :row="row" />
      </template>
      <template #full-screen-globals>
        <ModalEndJobs
          :show="selectedRowsIds.length > 0"
          :job-ids="selectedRowsIds"
          :refetch-queries="[query]"
          @cancel="selectedRowsIds = []"
          @submitted="selectedRowsIds = []"
        />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import { ref } from 'vue'
import { WdsIconNameEnum } from '@worksome/wds-components'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import JobActionColumn from '@/components/GraphqlDataTable/columns/Job/JobActionColumn.vue'
import { JobOrderByColumn, SortOrder } from '@/gql/graphql'
import { DataTableBulkAction } from '@/components/GraphqlDataTable/types'
import { $t } from '@/composables/translation'
import ModalEndJobs from '@/components/Job/Table/ModalEndJobs.vue'

const fullscreen = ref(false)

const query = graphql(`
  query JobsContractsQuery(
    $accounts: [ID!]
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [JobsOrderByClauseInput!]
    $jobOwners: [ID!]
    $hasBids: Boolean
    $hasHire: Boolean
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
    $rateTypes: [RateType!]
    $locationPreferences: [LocationPreference!]
    $commitment: [Association!]
    $skills: [String!]
    $seniority: [ExpectedExperienceLevel!]
    $customFields: [CustomFieldTypeValueInput!]
    $status: [JobStatus!]
  ) {
    jobs(
      accounts: $accounts
      search: $search
      page: $page
      first: $first
      hasBids: $hasBids
      hasHire: $hasHire
      rateTypes: $rateTypes
      associations: $commitment
      locationPreferences: $locationPreferences
      owners: $jobOwners
      skills: $skills
      experienceLevel: $seniority
      orderBy: $orderBy
      customFields: $customFields
      startDateRange: $startDateRange
      endDateRange: $endDateRange
      statuses: $status
    ) {
      paginatorInfo {
        ...PaginatorInfoFragment
      }
      data {
        ...JobCreatedAtColumn
        ...JobSharedChannelsColumn
        ...JobStatusColumn
        ...JobHireAndPoNumberColumn
        ...JobStartDateColumn
        ...JobEndDateColumn
        ...JobCandidatesBidsHiresColumn
        ...RateColumnJob
        ...JobOwnersColumn
        ...JobActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: JobOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}

const selectedRowsIds = ref<string[]>([])

const jobBulkActions: DataTableBulkAction[] = [
  {
    name: $t('End jobs'),
    icon: WdsIconNameEnum.CLOSE_OUTLINE,
    type: 'error',
    action: (rows) => {
      selectedRowsIds.value = Object.values(rows).map((row) => (row as any)?.id)
    },
  },
]
</script>
